import {
  IngestionDocumentReviewFragment,
  IngestionDocumentReviewStatus,
} from '@client/graphql/__generated__/types';

export enum DocumentReviewStatus {
  APPROVED = 'approved',
  RETURNED = 'returned',
}

/**
 * Get the document review status for approved/returned documents
 */
export function getDocumentReviewStatus(
  documentReview?: IngestionDocumentReviewFragment | null
): DocumentReviewStatus | null {
  if (!documentReview) {
    return null;
  }

  return documentReview.status === IngestionDocumentReviewStatus.APPROVED
    ? DocumentReviewStatus.APPROVED
    : DocumentReviewStatus.RETURNED;
}

/**
 * Get the display text for a document review status
 */
export function getDocumentReviewStatusText(
  review?: IngestionDocumentReviewFragment | null
): string {
  if (!review) return 'Pending Review';

  switch (review.status) {
    case IngestionDocumentReviewStatus.APPROVED:
      return 'Approved';
    case IngestionDocumentReviewStatus.RETURNED:
      return 'Returned';
    default:
      return 'Pending Review';
  }
}

/**
 * Get the color theme token for a document review status
 */
export function getDocumentReviewStatusColor(
  review?: IngestionDocumentReviewFragment | null
): string {
  if (!review) return 'compliance.text.secondary';

  switch (review.status) {
    case IngestionDocumentReviewStatus.APPROVED:
      return 'compliance.status.success';
    case IngestionDocumentReviewStatus.RETURNED:
      return 'compliance.text.primary';
    default:
      return 'compliance.text.secondary';
  }
}

/**
 * Get the color for a document review status
 */
export function getDocumentReviewStatusColorFromStatus(
  status: DocumentReviewStatus | IngestionDocumentReviewStatus
): string {
  switch (status) {
    case DocumentReviewStatus.APPROVED:
    case IngestionDocumentReviewStatus.APPROVED:
      return 'compliance.status.success';
    case DocumentReviewStatus.RETURNED:
    case IngestionDocumentReviewStatus.RETURNED:
      return 'compliance.text.primary';
    default:
      return 'compliance.text.secondary';
  }
}
